import { Button } from '@talentmesh/ui/components/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { cn } from '@talentmesh/ui/lib/utils';

import { type DragEventHandler } from 'react';

import { type HTMLPropsRef, type MRT_RowData, type MRT_TableInstance } from '../../types';
import { type ActionIconProps } from '../../types/mrt-ui-props';
import classes from './MRT_GrabHandleButton.module.css';

interface Props<TData extends MRT_RowData> {
    actionIconProps?: ActionIconProps & HTMLPropsRef<HTMLButtonElement>;
    onDragEnd: DragEventHandler<HTMLButtonElement>;
    onDragStart: DragEventHandler<HTMLButtonElement>;
    table: MRT_TableInstance<TData>;
}

export const MRT_GrabHandleButton = <TData extends MRT_RowData>({
    actionIconProps,
    onDragEnd,
    onDragStart,
    table: {
        options: {
            icons: { IconGripHorizontal },
            localization: { move },
        },
    },
}: Props<TData>) => {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    {...actionIconProps}
                    aria-label={(actionIconProps?.title as string | undefined) ?? move}
                    className={cn(
                        'mrt-grab-handle-button text-muted-foreground',
                        classes['grab-icon'],
                        actionIconProps?.className,
                    )}
                    draggable
                    onClick={(e) => {
                        e.stopPropagation();
                        actionIconProps?.onClick?.(e);
                    }}
                    onDragEnd={onDragEnd}
                    onDragStart={onDragStart}
                    size="icon-2xs"
                    variant="ghost"
                >
                    <IconGripHorizontal className="size-4" />
                </Button>
            </TooltipTrigger>
            <TooltipContent hideWhenDetached side="bottom">
                {(actionIconProps?.title as string | undefined) ?? move}
            </TooltipContent>
        </Tooltip>
    );
};
